import { type TenantSupabaseClient, getTenantClient } from '@sazeo/supabase-tenant';

// Lazy proxy — defers getTenantClient() to first property access.
// This lets admin-app bundle @sazeo/sdk (transitively via @sazeo/ui) without
// crashing at module-init time when VITE_SUPABASE_URL is absent.
// Tenant-app and hr-app always have the env vars, so their first real
// query call initializes the client as before.
export const supabase = new Proxy({} as TenantSupabaseClient, {
  get(_target, prop) {
    return getTenantClient()[prop as keyof TenantSupabaseClient];
  },
});
